import { RENEW_MEETING } from '../Types';
import { createConfiguration } from '@studio/chime/configuration/createConfiguration';
import {
  setAudioInputDevice,
  setAudioOutputDevice,
  setAttendeeCameraStatus
} from '@shoflo/studio-redux/actions';
import { setProgram } from 'actions/Broadcast';
import initializeMeetingSession from '../../containers/pages/Broadcast/initializeMeetingSession';
import { handleMuteStatus } from '../SocketHandler';
import {
  startVideoInput,
  startLocalVideoTile
} from '@studio/chime/audioVideo/audioVideoHelpers';
import { batch } from 'react-redux';

/**
 * Series of actions to move over a presenter ot a new meeting
 * type RenewMeeting {
 *   meetingResponse: MeetingResponse;
 *   newAttendeeList: Attendees[];
 * }
 * @param payload RenewMeeting
 * @returns {(function(*, *): void)|*}
 */
function renewMeeting(payload) {
  return async (dispatch, getState) => {
    const {
      meeting: { attendeeResponse },
      audioInputDevice,
      audioOutputDevice,
      videoInputDevice,
      attendeeCameraStatus,
      isAudioMuted
    } = getState();

    const { meetingResponse, newAttendeeList } = payload;

    // If the local attendee matches the attendee who was dismissed, fire the action
    const attendeeId = attendeeResponse?.Attendee?.AttendeeId;

    const newAttendeeSource = newAttendeeList.find(
      attendee => attendee.attendeeId === attendeeId
    );

    if (newAttendeeSource) {
      const { attendeeResponse: newAttendeeResponse, chatToken } =
        newAttendeeSource;

      const meeting = createConfiguration(meetingResponse, newAttendeeResponse);

      batch(() => {
        /** Set up new meeting */
        dispatch({
          type: RENEW_MEETING,
          payload: { ...meeting, chatToken }
        });

        /** Set attendee audio input device */
        dispatch(setAudioInputDevice(audioInputDevice));

        /** Set output device */
        dispatch(setAudioOutputDevice(audioOutputDevice));

        /** Check camera status for the new attendee */
        const newAttendeeId = meeting.attendeeResponse?.Attendee?.AttendeeId;

        const isCameraOn = attendeeCameraStatus[attendeeId];

        /** Set attendee cam status */
        dispatch(
          setAttendeeCameraStatus(newAttendeeId, isCameraOn, setProgram)
        );

        /** St the attendee mute status */
        dispatch(handleMuteStatus(isAudioMuted));
      });

      await startVideoInput(meeting.meetingSession, videoInputDevice);
      /** Start video tile */
      startLocalVideoTile(meeting.meetingSession);

      /** join meeting session */
      initializeMeetingSession(
        meeting.meetingSession,
        dispatch,
        attendeeResponse,
        meetingResponse,
        videoInputDevice
      );
    }
  };
}

export default renewMeeting;
